import {
  CANCEL_APPOINTMENT_FAILURE,
  CANCEL_APPOINTMENT_START,
  CANCEL_APPOINTMENT_SUCCESS,
  EXPORT_APPOINTMENTS_CSV_FAILURE,
  EXPORT_APPOINTMENTS_CSV_START,
  EXPORT_APPOINTMENTS_CSV_SUCCESS,
  EXPORT_APPOINTMENTS_ASYNC_START,
  EXPORT_APPOINTMENTS_ASYNC_SUCCESS,
  EXPORT_APPOINTMENTS_ASYNC_FAILURE,
  EXPORT_APPOINTMENTS_PROGRESS_UPDATE,
  EXPORT_APPOINTMENTS_POLLING_COMPLETE,
  RESET_EXPORT_STATE,
  FETCH_ALL_APPOINTMENTS_FAILURE,
  FETCH_ALL_APPOINTMENTS_START,
  FETCH_ALL_APPOINTMENTS_SUCCESS,
  FETCH_PAGINATED_CLIENTS_FAILURE,
  FETCH_PAGINATED_CLIENTS_START,
  FETCH_PAGINATED_CLIENTS_SUCCESS,
  FETCH_PAGINATED_PROVIDERS_FAILURE,
  FETCH_PAGINATED_PROVIDERS_START,
  FETCH_PAGINATED_PROVIDERS_SUCCESS,
  FETCH_PROVIDER_AVAILABILITY_FAILURE,
  FETCH_PROVIDER_AVAILABILITY_START,
  FETCH_PROVIDER_AVAILABILITY_SUCCESS,
  RESET_APPOINTMENTS_STATE,
  RESET_CLIENTS_AVAILABILITY,
  RESET_FILTERS,
  RESET_PROVIDER_AVAILABILITY,
  RESET_SELECTED_APPOINTMENT_ID,
  RESET_SPECIFIC_DAYS_APPOINTMENTS_STATE,
  SCHEDULE_APPOINTMENT_FAILURE,
  SCHEDULE_APPOINTMENT_START,
  SCHEDULE_APPOINTMENT_SUCCESS,
  SET_PROVIDER_DETAILS,
  SET_SELECTED_APPOINTMENT_ID,
  UPDATE_APPOINTMENT_FAILURE,
  UPDATE_APPOINTMENT_START,
  UPDATE_APPOINTMENT_SUCCESS,
  UPDATE_FETCHED_PROVIDERS,
  FETCH_APPOINTMENT_ACTIVITY_LOGS_START,
  FETCH_APPOINTMENT_ACTIVITY_LOGS_SUCCESS,
  FETCH_APPOINTMENT_ACTIVITY_LOGS_FAILURE,
  RESET_APPOINTMENT_ACTIVITY_LOGS,
} from './calendar.constants';
import {
  AppointmentsActions,
  AvailabilitySlotsResponse,
  CancelAppointmentPayload,
  CancelAppointmentResponse,
  ClientsActions,
  FetchAllAppointmentsPayload,
  FetchAllAppointmentsResponse,
  FetchedClientsResponse,
  FetchPaginatedClientsPayload,
  FetchPaginatedProvidersStartPayload,
  FetchProviderAvailabilityPayload,
  NormalizedFetchedPrescribers,
  NormalizedFetchedTherapists,
  ProviderAvailabilityActions,
  QueryKeysType,
  ScheduleAppointmentPayload,
  ScheduleAppointmentResponse,
  SetProviderDetailsPayload,
  UpdateAppointmentPayload,
  UpdateAppointmentResponse,
  // Activity Logs
  ActivityLogsActions,
  ActivityLogsResponse,
  FetchAppointmentActivityLogsStartPayload,
  // Async Export
  ExportAsyncResponse,
  ExportProgressResponse,
} from './calendar.types';
import {ExportAsyncActions} from './calendar-actions.types';

export function fetchProviderAvailabilityStart({
  providerId,
  calendarId,
  eventTypeTitle,
  appointmentType,
  yearAndMonth,
  state,
  duration,
  callback,
}: FetchProviderAvailabilityPayload): ProviderAvailabilityActions {
  return {
    type: FETCH_PROVIDER_AVAILABILITY_START,
    payload: {
      providerId,
      calendarId,
      eventTypeTitle,
      appointmentType,
      yearAndMonth,
      state,
      duration,
      callback,
    },
  };
}

export function fetchProviderAvailabilityFailure(): ProviderAvailabilityActions {
  return {
    type: FETCH_PROVIDER_AVAILABILITY_FAILURE,
  };
}

export function fetchProviderAvailabilitySuccess({
  providerId,
  appointmentTypeId,
  appointmentTypeName,
  category,
  slots,
}: AvailabilitySlotsResponse): ProviderAvailabilityActions {
  return {
    type: FETCH_PROVIDER_AVAILABILITY_SUCCESS,
    payload: {
      providerId,
      appointmentTypeId,
      appointmentTypeName,
      category,
      slots,
    },
  };
}

export function setProviderDetails(
  payload: SetProviderDetailsPayload,
): ProviderAvailabilityActions {
  return {
    type: SET_PROVIDER_DETAILS,
    payload,
  };
}

export function updateFetchedProviders(
  providers: NormalizedFetchedTherapists | NormalizedFetchedPrescribers,
): ProviderAvailabilityActions {
  return {
    type: UPDATE_FETCHED_PROVIDERS,
    payload: providers,
  };
}

export function resetProviderAvailability(): ProviderAvailabilityActions {
  return {
    type: RESET_PROVIDER_AVAILABILITY,
  };
}

export function fetchPaginatedProvidersStart(
  payload: FetchPaginatedProvidersStartPayload,
): ProviderAvailabilityActions {
  return {
    type: FETCH_PAGINATED_PROVIDERS_START,
    payload,
  };
}

export function fetchPaginatedProvidersFailure(): ProviderAvailabilityActions {
  return {
    type: FETCH_PAGINATED_PROVIDERS_FAILURE,
  };
}

export function fetchPaginatedProvidersSuccess(
  payload: NormalizedFetchedTherapists | NormalizedFetchedPrescribers,
): ProviderAvailabilityActions {
  return {
    type: FETCH_PAGINATED_PROVIDERS_SUCCESS,
    payload,
  };
}

// Fetch all appointments
export function fetchAllAppointmentsStart(
  payload: FetchAllAppointmentsPayload,
): AppointmentsActions {
  return {
    type: FETCH_ALL_APPOINTMENTS_START,
    payload,
  };
}
export function fetchAllAppointmentsFailure(
  payload: QueryKeysType,
): AppointmentsActions {
  return {
    type: FETCH_ALL_APPOINTMENTS_FAILURE,
    payload,
  };
}
export function fetchAllAppointmentsSuccess(
  payload: FetchAllAppointmentsResponse,
): AppointmentsActions {
  return {
    type: FETCH_ALL_APPOINTMENTS_SUCCESS,
    payload,
  };
}

export function resetFilters(): AppointmentsActions {
  return {
    type: RESET_FILTERS,
  };
}

// Schedule appointment
export function scheduleAppointmentStart(
  payload: ScheduleAppointmentPayload,
): AppointmentsActions {
  return {
    type: SCHEDULE_APPOINTMENT_START,
    payload,
  };
}
export function scheduleAppointmentFailure(): AppointmentsActions {
  return {
    type: SCHEDULE_APPOINTMENT_FAILURE,
  };
}
export function scheduleAppointmentSuccess(
  payload: ScheduleAppointmentResponse,
): AppointmentsActions {
  return {
    type: SCHEDULE_APPOINTMENT_SUCCESS,
    payload,
  };
}

// Cancel appointment
export function cancelAppointmentStart(
  payload: CancelAppointmentPayload,
): AppointmentsActions {
  return {
    type: CANCEL_APPOINTMENT_START,
    payload,
  };
}
export function cancelAppointmentFailure(): AppointmentsActions {
  return {
    type: CANCEL_APPOINTMENT_FAILURE,
  };
}
export function cancelAppointmentSuccess(
  payload: CancelAppointmentResponse,
): AppointmentsActions {
  return {
    type: CANCEL_APPOINTMENT_SUCCESS,
    payload,
  };
}

// Update appointment
export function updateAppointmentStart(
  payload: UpdateAppointmentPayload,
): AppointmentsActions {
  return {
    type: UPDATE_APPOINTMENT_START,
    payload,
  };
}
export function updateAppointmentFailure(): AppointmentsActions {
  return {
    type: UPDATE_APPOINTMENT_FAILURE,
  };
}
export function updateAppointmentSuccess(
  payload: UpdateAppointmentResponse,
): AppointmentsActions {
  return {
    type: UPDATE_APPOINTMENT_SUCCESS,
    payload,
  };
}

export function setSelectedAppointmentId(payload: string): AppointmentsActions {
  return {
    type: SET_SELECTED_APPOINTMENT_ID,
    payload,
  };
}

export function resetSelectedAppointmentId(): AppointmentsActions {
  return {
    type: RESET_SELECTED_APPOINTMENT_ID,
  };
}

export function resetAppointmentsState(): AppointmentsActions {
  return {
    type: RESET_APPOINTMENTS_STATE,
  };
}

export function resetSpecificDaysAppointmentsState(
  payload: Date,
): AppointmentsActions {
  return {
    type: RESET_SPECIFIC_DAYS_APPOINTMENTS_STATE,
    payload,
  };
}

// Export appointments CSV
export function exportAppointmentsCsvStart(payload: {
  startDate: string;
  endDate: string;
  includeCanceled?: boolean;
  timezone: string;
  callback?: () => void;
}): AppointmentsActions {
  return {
    type: EXPORT_APPOINTMENTS_CSV_START,
    payload,
  };
}

export function exportAppointmentsCsvSuccess(): AppointmentsActions {
  return {
    type: EXPORT_APPOINTMENTS_CSV_SUCCESS,
  };
}

export function exportAppointmentsCsvFailure(): AppointmentsActions {
  return {
    type: EXPORT_APPOINTMENTS_CSV_FAILURE,
  };
}

// Fetch paginated patients
export function fetchPaginatedClientsStart(
  payload: FetchPaginatedClientsPayload,
): ClientsActions {
  return {
    type: FETCH_PAGINATED_CLIENTS_START,
    payload,
  };
}

export function fetchPaginatedClientsFailure(): ClientsActions {
  return {
    type: FETCH_PAGINATED_CLIENTS_FAILURE,
  };
}

export function fetchPaginatedClientsSuccess(
  payload: FetchedClientsResponse, // normalized clients response
): ClientsActions {
  return {
    type: FETCH_PAGINATED_CLIENTS_SUCCESS,
    payload,
  };
}

export function resetClientsAvailability(): ClientsActions {
  return {type: RESET_CLIENTS_AVAILABILITY};
}

export function fetchAppointmentActivityLogsStart(
  payload: FetchAppointmentActivityLogsStartPayload,
): ActivityLogsActions {
  return {
    type: FETCH_APPOINTMENT_ACTIVITY_LOGS_START,
    payload,
  };
}

export function fetchAppointmentActivityLogsSuccess(
  calcomBookingUid: string,
  response: ActivityLogsResponse,
): ActivityLogsActions {
  return {
    type: FETCH_APPOINTMENT_ACTIVITY_LOGS_SUCCESS,
    payload: {calcomBookingUid, response},
  };
}

export function fetchAppointmentActivityLogsFailure(payload?: {
  calcomBookingUid?: string;
}): ActivityLogsActions {
  return {
    type: FETCH_APPOINTMENT_ACTIVITY_LOGS_FAILURE,
    payload,
  };
}

export function resetAppointmentActivityLogs(): ActivityLogsActions {
  return {
    type: RESET_APPOINTMENT_ACTIVITY_LOGS,
  };
}

export function exportAppointmentsAsyncStart(payload: {
  startDate: string;
  endDate: string;
  includeCanceled?: boolean;
  timezone: string;
}): ExportAsyncActions {
  return {
    type: EXPORT_APPOINTMENTS_ASYNC_START,
    payload,
  };
}

export function exportAppointmentsAsyncSuccess(
  payload: ExportAsyncResponse,
): ExportAsyncActions {
  return {
    type: EXPORT_APPOINTMENTS_ASYNC_SUCCESS,
    payload,
  };
}

export function exportAppointmentsAsyncFailure(
  payload?: string,
): ExportAsyncActions {
  return {
    type: EXPORT_APPOINTMENTS_ASYNC_FAILURE,
    payload,
  };
}

export function exportAppointmentsProgressUpdate(
  payload: ExportProgressResponse,
): ExportAsyncActions {
  return {
    type: EXPORT_APPOINTMENTS_PROGRESS_UPDATE,
    payload,
  };
}

export function exportAppointmentsPollingComplete(
  payload: ExportProgressResponse,
): ExportAsyncActions {
  return {
    type: EXPORT_APPOINTMENTS_POLLING_COMPLETE,
    payload,
  };
}

export function resetExportState(): ExportAsyncActions {
  return {
    type: RESET_EXPORT_STATE,
  };
}
